export default "__VITE_ASSET__DfglNQry__"